import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap-5';

import { startEmailGroup } from './store/actions/requirements_set';

export class RequirementsSetActionsDropdown extends React.Component {
  static propTypes = {
    canAccessCrm: PropTypes.bool.isRequired,
    requirementsSets: PropTypes.array.isRequired,
    onCreateEmailGroup: PropTypes.func.isRequired,
  };

  handleEmailToGroup = () => {
    const { onCreateEmailGroup } = this.props;
    onCreateEmailGroup(this.requirementsSetsParents());
  };

  isDisabled = () => {
    const { canAccessCrm, requirementsSets } = this.props;
    return !canAccessCrm || requirementsSets.length < 1;
  }

  render() {
    return (
      this.renderDropdown()
    );
  }

  renderDropdown() {
    const { requirementsSets } = this.props;
    return (
      <Dropdown id="actions-dropdown">
        <Dropdown.Toggle disabled={this.isDisabled()}>
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {requirementsSets.length > 0 && this.renderDisplayedRequirementSetsOptions()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderDisplayedRequirementSetsOptions() {
    const { canAccessCrm } = this.props;
    return (
      <>
        {canAccessCrm && (
          <Dropdown.Item name="email-group" onClick={this.handleEmailToGroup}>Email Contacts</Dropdown.Item>
        )}
      </>
    );
  }

  requirementsSetsParents() {
    const { requirementsSets } = this.props;
    return requirementsSets.map(rs => ({ contactId: rs.parentId, contactType: rs.parentType }));
  }
}

const mapStateToProps = state => ({
  canAccessCrm: state.static.canAccessCrm,
  requirementsSets: state.search.requirementsSets,
});

const mapDispatchToProps = {
  onCreateEmailGroup: startEmailGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequirementsSetActionsDropdown);
